export default {
  header: {
    self: {},
    items: [{}],
  },
  aside: {
    self: {},
    items: [
      {
        title: "Dashboard",
        root: true,
        icon: "dashboard",
        submenu: [
          {
            title: "Operacional",
            page: "dashboard-operacional",
            noSubHeader: true,
          },
          {
            title: "Estratégica",
            page: "dashboard-estrategica",
            noSubHeader: true,
          },
        ],
      },
      {
        title: "Agendamentos",
        root: true,
        noSubHeader: true,
        noPadding: true,
        customParentKTContentStyle: { padding: 0 },
        customKTContentStyle: { padding: 0 },
        icon: "agendamento",
        page: "agendamento",
      },
      {
        title: "Caixa",
        icon: "caixa",
        submenu: [
          {
            title: "Comandas",
            page: "comandas",
          },
          {
            title: "Caixas",
            page: "caixa",
          },
          {
            title: "Histórico de caixas",
            page: "historico-caixas",
          },
        ],
      },
      {
        title: "Bar / Cozinha",
        root: true,
        icon: "bar_cozinha",
        page: "comanda-produto",
      },
      {
        title: "Gestão",
        root: true,
        icon: "gestao",
        submenu: [
          {
            title: "Horários de pico",
            noSubHeader: true,
            page: "horario-de-pico",
          },
          {
            title: "Horários de feriados",
            page: "horario-feriados",
          },
          {
            title: "Clientes",
            submenu: [
              {
                title: "Lista de clientes",
                page: "cliente",
              },
              {
                title: "Cadastrar clientes",
                page: "cliente/new",
              },
              {
                title: "Clientes bloqueados",
                page: "cliente-bloqueio",
              },
              {
                title: "Clientes recompras",
                page: "cliente-recompra",
              },
            ],
          },
          {
            title: "Estoque",
            submenu: [
              {
                title: "Estoque atual",
                page: "estoque/atual",
              },
              {
                title: "Entrada e saída",
                page: "estoque/entrada-saida",
              },
            ],
          },
        ],
      },
      {
        title: "Relatórios",
        root: true,
        icon: "relatorios",
        submenu: [
          {
            title: "Financeiro",
            submenu: [
              {
                title: "Vendas",
                page: "relatorio/relatorio15",
              },
              {
                title: "Formas de pagamento",
                page: "relatorio/relatorio18",
              },
              {
                title: "Faturamento",
                page: "relatorio/relatorio20",
              },
              {
                title: "Histórico de movimentações",
                page: "relatorio/relatorio01",
              },
            ],
          },
          {
            title: "Gestão",
            submenu: [
              {
                title: "Frequência do cliente",
                page: "relatorio/relatorio05",
              },
              {
                title: "Cliente por período e serviço",
                page: "relatorio/relatorio09",
              },
              {
                title: "Serviços",
                page: "relatorio/relatorio10",
              },
              {
                title: "Histórico de agendamentos",
                page: "relatorio/relatorio03",
              },
              {
                title: "Histórico de venda produtos",
                page: "relatorio/relatorio25",
              },
              {
                title: "Auditorias",
                page: "relatorio/relatorio37",
              },
            ],
          },
          {
            title: "Estoque",
            submenu: [
              {
                title: "Estoque atual",
                page: "relatorio/relatorio23",
              },
              {
                title: "Entrada e saída de estoque",
                page: "relatorio/relatorio12",
              },
            ],
          },
          {
            title: "Profissional",
            submenu: [
              {
                title: "Ticket médio por atendimento",
                page: "relatorio/relatorio08",
              },
              {
                title: "Ticket médio de clientes distintos",
                page: "relatorio/relatorio24",
                "custom-class": "menu-wrap",
              },
              {
                title: "Comissões de serviços",
                page: "relatorio/relatorio02",
              },
              {
                title: "Comissão de produtos",
                page: "relatorio/relatorio13",
              },
              {
                title: "Documentos",
                page: "relatorio/relatorio36",
              },
            ],
          },
          {
            title: "Marketing e experiência",
            submenu: [
              {
                title: "Captação de clientes",
                page: "relatorio/relatorio11",
              },
              {
                title: "Novos clientes",
                page: "relatorio/relatorio17",
              },
              {
                title: "Clientes ausentes",
                page: "relatorio/relatorio16",
              },
              {
                title: "Avaliação",
                page: "relatorio/relatorio06",
              },
              {
                title: "Aniversariantes por período",
                page: "relatorio/relatorio14",
              },
              {
                title: "Lista de espera de plano",
                page: "relatorio/relatorio29",
              },
              {
                title: "Clientes sem preferência",
                page: "relatorio/relatorio33",
              },
            ],
          },
          {
            title: "Assinaturas",
            submenu: [
              {
                title: "Quantidade de assinantes",
                page: "relatorio/relatorio19",
              },
              {
                title: "Cancelados por período",
                page: "relatorio/relatorio21",
              },
              {
                title: "Vendas novas por período",
                page: "relatorio/relatorio22",
              },
              {
                title: "Histórico de Transações Planos",
                page: "relatorio/relatorio04",
              },
              {
                title: "Vendas por origem",
                page: "relatorio/relatorio30",
              },
              {
                title: "Alterações nas assinaturas",
                page: "relatorio/relatorio35",
              },
            ],
          },
          {
            title: "Ticket médio",
            submenu: [
              {
                title: "Por profissional",
                page: "relatorio/relatorio26",
              },
              {
                title: "Por cliente",
                page: "relatorio/relatorio27",
              },
              {
                title: "Por atendimento",
                page: "relatorio/relatorio28",
              },
            ],
          },
        ],
      },
      {
        title: "Assinaturas",
        icon: "wallet",
        submenu: [
          {
            title: "Cliente pré aprovado",
            page: "pre-aprovado",
          },
          {
            title: "Cliente pré cancelado",
            page: "pre-cancelado",
          },
          {
            title: "Dashboard CashPag",
            page: "dashboard-gateway",
          },
          {
            title: "Transações financeiras",
            page: "transacoes-financeiras",
          },
          {
            title: "Calendário de assinaturas",
            page: "calendario-assinaturas",
          },
          {
            title: "Calendário de recebíveis",
            page: "calendario-recebiveis",
          },
          {
            title: "Inadimplentes",
            page: "recobrar-assinaturas",
          },
          {
            title: "Alterar assinaturas",
            page: "alterar-assinaturas",
          },
          {
            title: "Migração de clientes CashPag",
            page: "cliente/migracao",
          },
          {
            title: "Planos",
            submenu: [
              {
                title: "Criar planos",
                page: "plano/new",
              },
              {
                title: "Exibição de planos",
                page: "exibicao-planos",
              },
              {
                title: "Listagem de plano",
                page: "plano",
              },
            ],
          },
          {
            title: "Contratos ativos",
            page: "contratos-ativos",
          },
          {
            title: "Solicitar saque",
            page: "saque",
          },
          {
            title: "D pote",
            submenu: [
              {
                title: "Relatório",
                page: "dpote/relatorio",
              },
              {
                title: "Históricos",
                page: "dpote/historicos",
              },
              {
                title: "Painel",
                page: "dpote/painel",
              },
            ],
          },
          {
            title: "Relatório de transações",
            page: "relatorio-transacoes",
          },
        ],
      },
      {
        title: "Financeiro",
        icon: "financeiro",
        submenu: [
          {
            title: "Gerar comissões",
            page: "comissoes",
          },
          {
            title: "Balanço",
            page: "movimentacoes/balanco",
          },
          {
            title: "Contas a pagar",
            page: "movimentacoes/contas-a-pagar",
          },
          {
            title: "Contas a receber",
            page: "movimentacoes/contas-a-receber",
          },
          {
            title: "Criar despesa",
            page: "movimentacoes/contas-a-pagar/new",
          },
          {
            title: "Criar receita",
            page: "movimentacoes/contas-a-receber/new",
          },
          {
            title: "Cadastros",
            submenu: [
              {
                title: "Contas bancárias",
                page: "contas-bancarias",
              },
              {
                title: "Categorias Financeiras",
                page: "categorias-financeiras",
              },
              {
                title: "Formas de pagamento",
                submenu: [
                  {
                    title: "De comanda",
                    page: "formas-pagamento/comandas",
                  },
                  {
                    title: "De despesa",
                    page: "formas-pagamento/despesas",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: "Marketing",
        root: true,
        icon: "marketing",
        submenu: [
          {
            title: "Clube do assinante",
            submenu: [
              {
                title: "Empresas Parceiras",
                page: "clube/empresa-parceira",
              },
              {
                title: "Banners",
                page: "clube/banner",
              },
              {
                title: "Utilização dos cupons",
                page: "clube/utilizacao-cupons",
              },
            ],
          },
          {
            title: "Banners Painel Cliente",
            page: "banners",
          },
          {
            title: "Promoções",
            submenu: [
              {
                title: "Serviços",
                page: "promocao/servico",
              },
            ],
          },
          {
            title: "Configurações de WhatsApp",
            page: "configuracao-whatsapp",
          },
        ],
      },
      {
        title: "Preencher dados do Gateway",
        icon: "gateway",
        page: "completar-conta",
      },
      {
        title: "Minha Empresa",
        root: true,
        icon: "minha_empresa",
        submenu: [
          {
            title: "Dados",
            page: "perfil",
          },
          {
            title: "Grupos de acesso",
            page: "grupo-permissao",
          },
          {
            title: "Cadastros",
            submenu: [
              {
                title: "Clientes",
                page: "cliente",
              },
              {
                title: "Filiais",
                page: "filial",
              },
              {
                title: "Profissionais",
                submenu: [
                  {
                    title: "Cadastrar profissional",
                    page: "usuario/new",
                  },
                  {
                    title: "Profissional destaque",
                    page: "exibicao-profissionais",
                  },
                  {
                    title: "Listagem profissionais",
                    page: "usuario",
                  },
                ],
              },
              {
                title: "Serviços",
                submenu: [
                  {
                    title: "Cadastrar serviços",
                    page: "servico/new",
                  },
                  {
                    title: "Exibição de serviços",
                    page: "exibicao-servicos",
                  },
                  {
                    title: "Listagem de serviços",
                    page: "servico",
                  },
                ],
              },
              {
                title: "Produtos",
                page: "produtos",
              },
              {
                title: "Categorias",
                page: "categorias",
              },
            ],
          },
        ],
      },
      {
        separator: true,
      },
      {
        simpleText: "PREMIUM",
      },
    //   {
    //   	title: "Escola Cashbarber",
    //   	root: true,
    //   	icon: "fas fa-graduation-cap",
    //   	page: "escola-cashbarber",
    //   },
      {
        title: "Acessar Pump",
        root: true,
        icon: "pump",
        page: "pump",
        rightIcon: "pump",
      },
    ],
  },
};
